import axios from 'axios';
import { useState } from 'react';
import { Navigate, useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faEye, faEyeSlash, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './login.css';

// Установка пароля по ссылке из приглашения (accept-invite). Клон Reset.tsx.
export const SetPassword = () => {
  const [password, setPassword]               = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [showPass, setShowPass]               = useState(false);
  const [showConfirm, setShowConfirm]         = useState(false);
  const [loading, setLoading]                 = useState(false);
  const [redirect, setRedirect]               = useState(false);
  const [error, setError]                     = useState<string | null>(null);
  const { token } = useParams();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!password || !passwordConfirm) {
      setError('Please fill in both password fields.');
      return;
    }
    if (password !== passwordConfirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()\-_=+[\]{};':"\\|,.<>/?`~]).{8,}$/.test(password)) {
      setError('Password must be at least 8 characters and include uppercase, lowercase and a special character.');
      return;
    }

    setLoading(true);
    try {
      await axios.post('accept-invite', { token, password, password_confirm: passwordConfirm });
      setRedirect(true);
    } catch {
      setError('This invitation link has expired or is invalid. Please ask your administrator to resend it.');
    } finally {
      setLoading(false);
    }
  };

  if (redirect) return <Navigate to='/login' />;

  return (
    <div className='lp-root'>
      <div className='lp-mesh' />
      <div className='lp-mesh-noise' />

      <div className='lp-page'>
        <div className='lp-right'>
          <div className='lp-form-card'>
            <div className='lp-card-stripe' />
            <div className='lp-card-body'>

              <div className='lp-greeting'>Set your password</div>
              <div className='lp-greeting-sub'>
                You've been invited to TimeBerlo. Choose a password to activate your account.
              </div>

              {error && <div className='lp-err-banner'>{error}</div>}

              <form onSubmit={submit}>
                <div className='lp-field'>
                  <div className='lp-field-label'><span>New password</span></div>
                  <div className='lp-inp-wrap'>
                    <span className='lp-inp-icon'><FontAwesomeIcon icon={faLock} /></span>
                    <input
                      className='lp-inp'
                      type={showPass ? 'text' : 'password'}
                      placeholder='Enter new password'
                      autoComplete='new-password'
                      style={{ paddingRight: '44px' }}
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                    />
                    <button type='button' className='lp-inp-eye' aria-label={showPass ? 'Hide password' : 'Show password'} onClick={() => setShowPass(p => !p)}>
                      <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>

                <div className='lp-field'>
                  <div className='lp-field-label'><span>Confirm password</span></div>
                  <div className='lp-inp-wrap'>
                    <span className='lp-inp-icon'><FontAwesomeIcon icon={faLock} /></span>
                    <input
                      className='lp-inp'
                      type={showConfirm ? 'text' : 'password'}
                      placeholder='Repeat your password'
                      autoComplete='new-password'
                      style={{ paddingRight: '44px' }}
                      value={passwordConfirm}
                      onChange={e => setPasswordConfirm(e.target.value)}
                    />
                    <button type='button' className='lp-inp-eye' aria-label={showConfirm ? 'Hide password' : 'Show password'} onClick={() => setShowConfirm(p => !p)}>
                      <FontAwesomeIcon icon={showConfirm ? faEyeSlash : faEye} />
                    </button>
                  </div>
                </div>

                <button type='submit' className='lp-btn-submit' disabled={loading} style={{ marginTop: 8 }}>
                  {loading
                    ? <><div className='lp-spinner' /><span>Activating…</span></>
                    : <><span>Set password &amp; continue</span><span className='lp-btn-arrow'>→</span></>
                  }
                </button>
              </form>

              <div className='lp-back-row'>
                <Link to='/login' className='lp-back-link'>
                  <FontAwesomeIcon icon={faArrowLeft} />
                  Back to Sign in
                </Link>
              </div>

            </div>
          </div>

          <div className='lp-trust-row'>
            <div className='lp-trust-item'>🔒 <span>256-bit SSL</span></div>
            <div className='lp-trust-dot' />
            <div className='lp-trust-item'>🛡 <span>GDPR compliant</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
